import { DatePipe, NgClass, NgTemplateOutlet, SlicePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { CustomBookingMessageTemplate } from '../../../../../app/db-models/widget-conf-dao';
import { environment } from '../../../../../environments/environment';
import { DATE_ISO_FORMAT } from '../../../../constants/date.constants';
import { TEMPLATE_CONSTANT } from '../../../../constants/template.constant';
import { TRANSLATION_TEMPLATES } from '../../../../constants/translation-templates-constants';
import { EventDateDao } from '../../../../db-models/event-date-dao';
import { EventCartItem } from '../../../../models/cart.model';
import { EventState } from '../../../../models/state.model';
import { DateUtilsService } from '../../../../services/date-utils.service';
import { EventsHelperService } from '../../../../services/events-helper.service';
import { WidgetUtilService } from '../../../../services/widget-util.service';
import { AlertComponent } from '../../../../shared/components/alert/alert.component';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { CalioMeetingTemplatePipe } from '../../../../shared/pipes/calio-meeting-template.pipe';
import { IsEmptyStringPipe } from '../../../../shared/pipes/is-empty-string.pipe';
import { TranslationPipe } from '../../../../shared/pipes/translation.pipe';
import { TrustHtmlPipe } from '../../../../shared/pipes/trust-html.pipe';
import { CwCheckboxRadioButtonComponent } from '../../../common/theme/cw-checkbox-radio-button/cw-checkbox-radio-button.component';

@Component({
  selector: 'app-event-slot',
  templateUrl: './event-slot.component.html',
  styleUrls: ['./event-slot.component.scss'],
  imports: [LoaderComponent, AlertComponent, NgClass, CwCheckboxRadioButtonComponent, FontAwesomeModule, SlicePipe, TranslateModule, TranslationPipe, TrustHtmlPipe, CalioMeetingTemplatePipe, IsEmptyStringPipe, NgTemplateOutlet, DatePipe]
})
export class EventSlotComponent {

  private dateUtilsService = inject(DateUtilsService);
  private eventsHelperService = inject(EventsHelperService);
  private translate = inject(TranslateService);
  private widgetUtilService = inject(WidgetUtilService);

  @Input() protected eventState: EventState;
  @Input() protected terminLoaded: Number;
  @Input() protected eventOnDate: EventDateDao[];
  @Input() protected bookedItems: EventCartItem[];
  @Input() protected cart: EventCartItem[];
  @Input() protected noEvents: Boolean;
  @Input() protected widgetTemplates = new Array<CustomBookingMessageTemplate>();
  @Input() protected lang: string;

  @Output() protected updateCartEvent = new EventEmitter<any>();
  @Output() protected gotoNextPageEvent = new EventEmitter<any>();

  protected readonly dateIsoFormat = DATE_ISO_FORMAT;
  protected readonly environment = environment;
  protected readonly templateContent = TRANSLATION_TEMPLATES;
  protected readonly templateConstant = TEMPLATE_CONSTANT;

  protected get timeFormat(): string {
    return this.dateUtilsService.userTimeFormat.date;
  }

  protected get datePipeWithComma(): string {
    return this.dateUtilsService.userDateTimeWithCommaFormat;
  }

  protected get dateTimeFormat(): string {
    return this.dateUtilsService.userDateTimeFormat.date;
  }

  protected hideEventCapacity = this.widgetUtilService.getWidgetConf().hide_event_capacity;
  protected showWidgetSlotLocation = this.widgetUtilService.getWidgetConf().show_widget_slot_location;
  protected loadMoreSlots = false;

  constructor() {
    this.translate.onLangChange.subscribe(lang => this.lang = lang.lang);
  }

  displayRegularData(event: EventDateDao): boolean {
    return this.eventsHelperService.displayRegularData(event);
  }

  displayWaitingData(event: EventDateDao): boolean {
    return this.eventsHelperService.displayWaitingData(event);
  }

  isSlotBooked(slotId: number): boolean {
    return this.eventsHelperService.isSlotBooked(slotId, this.bookedItems);
  }

  isTerminInCart(slotId: number): boolean {
    if (this.cart != null) {
      for (let i = this.cart.length - 1; i >= 0; i--) {
        if (this.cart[i].slotId === slotId) {
          return true;
        }
      }
    }
    return false;
  }

  updateCart(event: any, eventInfo: EventDateDao) {
    if (!this.displayRegularData(eventInfo)) {
      if (this.displayWaitingData(eventInfo)) {
        eventInfo.isWaitingList = true;
      }
    }

    this.updateCartEvent.emit({ event, eventInfo });
  }

  isWaitingAlertEnabled(): boolean {
    if (this.terminLoaded) {
      if (this.eventOnDate && this.eventOnDate.length > 0) {
        for (const eventSlot of this.eventOnDate) {
          if (eventSlot.regular_booking_count >= eventSlot.regular_capacity) {
            if (eventSlot.waitinglist_booking_count < eventSlot.waitinglist_capacity) {
              return true;
            }
          }
        }
        return false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  gotoNextPage(): void {
    this.gotoNextPageEvent.emit();
  }

  checkIfStartEndDatesAreEqual(startDate: Date, endDate: Date): boolean {
    return moment(moment(startDate).format(this.dateIsoFormat)).isSame(moment(moment(endDate).format(this.dateIsoFormat)));
  }

  loadMore(): void {
    this.loadMoreSlots = true;
  }
}
